import { createQueryKeys } from "@lukemorales/query-key-factory";
import { createInfiniteQuery } from "@/utils/infinite-query.helper";
import {
  getResourcesDetails,
  getSingleResponse,
  getSingleResponseDetail,
  getResourceCategoryData,
} from "@/api/actions/resource-actions";

export const resourceQuery = createQueryKeys("resources", {
  // Get all resources details page data
  all: (slug: string) => {
    const queryParams = { populate: "deep", sort: "publishedAt:DESC" };

    return {
      queryKey: [slug, queryParams],
      queryFn: () => getResourcesDetails(queryParams, slug),
    };
  },

  // Get all resources page data
  getSingleResponse: (slug: string) => {
    const queryParams = { populate: "deep" };

    return {
      queryKey: [slug, queryParams],
      queryFn: () => getSingleResponse(slug, queryParams),
    };
  },

  // Get resources details page data
  getSingleResponseDetail: (slug: string, id: string) => {
    const queryParams = { filters: { slug: { $eq: id } }, populate: "deep,6" };

    return {
      queryKey: [queryParams],
      queryFn: () => getSingleResponseDetail(slug, queryParams),
    };
  },
});

export const resourcesInfiniteQuery = {
  all: createInfiniteQuery(["_resources", "all"], getResourceCategoryData),
};
